"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const public_1 = require("../common/public");
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
const ArrowIcon_1 = require("../icons/ArrowIcon");
const Spinner_1 = require("../Spinner");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const calcArrowDirection = (direction) => {
    switch (direction) {
        case public_1.ARROW_DIRECTION.right:
            return 'rotate(90deg)';
        case public_1.ARROW_DIRECTION.down:
            return 'rotate(180deg)';
        case public_1.ARROW_DIRECTION.left:
            return 'rotate(270deg)';
        default:
            return 'rotate(0)';
    }
};
const WrapperArrowIcon = styled_components_1.default.div ``;
const ValueWrapper = styled_components_1.default.div `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${helpers_1.SPACING_S};
    min-height: ${helpers_1.FONT_LINE_HEIGHT_XL};

    ${StackView_1.StackView.selector} {
        ${WrapperArrowIcon} {
            display: flex;

            transform: ${({ arrowDirection }) => calcArrowDirection(arrowDirection)};
        }

        ${Text_1.Text.selector} {
            margin-left: 0;
            margin-right: ${helpers_1.SIZE_M};
        }
    }
`;
const Wrapper = styled_components_1.default.div `
    box-sizing: border-box;
    height: inherit;

    padding: ${helpers_1.SPACING_M} 0;

    text-align: center;
    font: ${helpers_1.BASE_FONT};
    color: ${({ theme }) => theme.colorTextMain};

    &:hover {
        background-color: ${({ theme }) => theme.colorHighlightLight};
    }

    &:active {
        background-color: ${({ theme }) => theme.colorHighlightDark};
    }
`;
exports.Tile = (0, helpers_1.createUIElement)('Tile', (_a, ref) => {
    var { className, srcIcon, title, value = '', arrowDirection = public_1.ARROW_DIRECTION.up, isLoading = false, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "srcIcon", "title", "value", "arrowDirection", "isLoading", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'tile', className: `vm-Tile ${className}`, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(Icon_1.Icon, { src: srcIcon, size: Icon_1.ICON_SIZES.xl }),
        react_1.default.createElement(ValueWrapper, { arrowDirection: arrowDirection }, isLoading ? (react_1.default.createElement(Spinner_1.Spinner, { size: 26 })) : (react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, direction: StackView_1.STACK_DIRECTION.row },
            react_1.default.createElement(WrapperArrowIcon, null,
                react_1.default.createElement(ArrowIcon_1.ArrowIconSvg, null)),
            react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.xl }, value)))),
        react_1.default.createElement(Text_1.Text, { align: Text_1.TEXT_ALIGN.center, size: Text_1.TEXT_SIZE.m }, title)));
});
//# sourceMappingURL=Tile.js.map